function SectionTestimonials2() {
    return (
        <>
            <div className="sx-testimonial-bx-2  m-b30">
                {/* TITLE START */}
                <div className="section-head center">
                    <div className="sx-head-s-title">Our Testimonials</div>
                    <div className="sx-head-l-title">
                        <h2 className="sx-title">What Clients Say?</h2>
                    </div>
                </div>
                {/* TITLE END */}
                <div className="owl-carousel testimonial-section-2 owl-btn-vertical-center">
                    {/*One block*/}
                    <div className="item">
                        <div className="testimonial-1  hover-animation-1 sx-bg-white">
                            <div className="testimonial-detail">
                                <div className="testimonial-user-info">
                                    <h4 className="testimonial-name">Sophia Bennett</h4>
                                </div>
                            </div>
                            <div className="testimonial-text">
                                <p>Working with this team has been a game-changer for our business. Their expertise and professionalism have helped us overcome challenges and achieve our goals seamlessly. Highly recommend!</p>
                            </div>
                            <div className="testimonial-footer">
                                <div className="testimonial-quote sx-text-primary">
                                    <i className="flaticon-quote" />
                                </div>
                                <ul className="sx-rating-st1">
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                </ul>
                                <span className="sx-review-count">(5 Reviews)</span>
                            </div>
                        </div>
                    </div>
                    {/*One two*/}
                    <div className="item">
                        <div className="testimonial-1  hover-animation-1 sx-bg-white">
                            <div className="testimonial-detail">
                                <div className="testimonial-user-info">
                                    <h4 className="testimonial-name">Liam Harris</h4>
                                </div>
                            </div>
                            <div className="testimonial-text">
                                <p>Exceptional service from start to finish. Their attention to detail and dedication to meeting our needs were truly impressive. We couldn’t be happier with the results!</p>
                            </div>
                            <div className="testimonial-footer">
                                <div className="testimonial-quote sx-text-primary">
                                    <i className="flaticon-quote" />
                                </div>
                                <ul className="sx-rating-st1">
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                </ul>
                                <span className="sx-review-count">(5 Reviews)</span>
                            </div>
                        </div>
                    </div>
                    {/*One three*/}
                    <div className="item">
                        <div className="testimonial-1  hover-animation-1 sx-bg-white">
                            <div className="testimonial-detail">
                                <div className="testimonial-user-info">
                                    <h4 className="testimonial-name">Emma Davis</h4>
                                </div>
                            </div>
                            <div className="testimonial-text">
                                <p>I’ve worked with several companies, but this team stands out. Their innovative approach and commitment to quality have made a significant impact on our operations.</p>
                            </div>
                            <div className="testimonial-footer">
                                <div className="testimonial-quote sx-text-primary">
                                    <i className="flaticon-quote" />
                                </div>
                                <ul className="sx-rating-st1">
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                </ul>
                                <span className="sx-review-count">(5 Reviews)</span>
                            </div>
                        </div>
                    </div>
                    {/*One four*/}
                    <div className="item">
                        <div className="testimonial-1  hover-animation-1 sx-bg-white">
                            <div className="testimonial-detail">
                                <div className="testimonial-user-info">
                                    <h4 className="testimonial-name">Noah Johnson</h4>
                                </div>
                            </div>
                            <div className="testimonial-text">
                                <p>Their professionalism and dedication are unmatched. The results they delivered went beyond our expectations, and we look forward to working with them again in the future.</p>
                            </div>
                            <div className="testimonial-footer">
                                <div className="testimonial-quote sx-text-primary">
                                    <i className="flaticon-quote" />
                                </div>
                                <ul className="sx-rating-st1">
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                </ul>
                                <span className="sx-review-count">(5 Reviews)</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionTestimonials2;
